import api from './api';

export const compareDocuments = async (fileA, fileB, prompt) => {
  const formData = new FormData();
  formData.append('file_a', fileA);
  formData.append('file_b', fileB);
  if (prompt) formData.append('prompt', prompt);

  const response = await api.post('/doc-compare/compare', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const getCompareStatus = async (taskId) => {
  const response = await api.get(`/doc-compare/status/${taskId}`);
  return response.data;
};

export const getCompareResult = async (taskId) => {
  const response = await api.get(`/doc-compare/result/${taskId}`);
  return response.data;
};
